import {getLocaleSettings} from '@wix/ambassador-multilingual-settings-v2-locale-settings/http';

import {editorReadyContext} from '@/editor.app';

export const createIsMultilingualModeEnabled = () => {
  return async () => {
    const httpClient = editorReadyContext?.flowAPI?.httpClient;

    if (!httpClient) {
      throw new Error('HttpClient not available in flowAPI');
    }

    const res = await httpClient.request(getLocaleSettings({}));

    if (!res.data?.localeSettings) {
      throw new Error('No locale settings found');
    }

    return res.data.localeSettings.multilingualModeEnabled;
  };
};
